import { z } from 'zod';

import { EmailStringSchema } from '../../common';

export enum BrandStatus {
  ACTIVE = 'active',
  CHURNED = 'churned',
  DELETED = 'deleted',
}
export const BrandReportQuerySchema = z.object({
  types: z.array(z.nativeEnum(BrandStatus)),
});

export const BrandReportHeaderSchema = z.object({
  ID: z.string(),
  Name: z.string(),
  'Email Address': EmailStringSchema,
  Version: z.enum(['1.0', '2.0', '3.0']).nullable(),
  Tier: z.string(),
  Host: z.boolean().pipe(z.coerce.string().toUpperCase()).nullable(),
  Activate: z.boolean().pipe(z.coerce.string().toUpperCase()).nullable(),
  Reserve: z.boolean().pipe(z.coerce.string().toUpperCase()).nullable(),
  'Country Code': z.string(),
  'Currency Code': z.string(),
  'Credit Card Fee Percentage': z.number(),
  'Payment Platform': z.string(),
  'Created At': z.string().datetime(),
  Status: z.string(),
  CSM: z.string().optional(),
  'Decision Makers': z.string().optional(),
  'Point of contacts': z.string().optional(),
  'Test brand': z.boolean().nullable().optional(),
  Live: z.boolean().nullable().optional(),
  'Churned At': z
    .union([z.string().trim().length(0), z.string().datetime()])
    .optional()
    .nullable(),
  'Launched At': z
    .union([z.string().trim().length(0), z.string().datetime()])
    .optional()
    .nullable(),
});
export type BrandReportWithHeader = z.infer<typeof BrandReportHeaderSchema>;
